import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    isOpenModalUE:false,
    eventDetailData:{
        id:null,
        title:"",
        desc:"",
        date_range:"",
        time_range:"",
        location:"",
        speaker:"",
        thumbnail:"",
        is_tentative:null
    }
}

export const upcomingEventsSlice = createSlice({
  name: 'upcoming_events',
  initialState,
  reducers: {
    setIsOpenModalUE: (state, action) => {
      state.isOpenModalUE = action.payload;
    },
    setEventDetailData: (state, action) => {
        state.eventDetailData = action.payload;
    }
  },
})

// Action creators are generated for each case reducer function
export const { setIsOpenModalUE, setEventDetailData } = upcomingEventsSlice.actions

export default upcomingEventsSlice.reducer